<template>
  <ImageGallery
      api-endpoint="/api/behind-scenes"
      title="Behind the Scenes"
      subtitle="A glimpse into the creative process."
  />
</template>

<script>
import ImageGallery from './ImageGallery.vue';

export default {
  name: 'BehindScenesGallery',
  components: {
    ImageGallery
  }
};
</script>